module.exports = __webpack_public_path__ + "static/clientTouchEnglishAndGo-3450ac70fefee1306ad4a990df89d73c.jpg";